export interface Booking {
  id: string;
  user_id: number;
  token: string;
  room_id: string;
  appointment_at: string;
  agenda: string;
  guest_name: string | null;
  guest_email: string | null;
  banker_prep_notes: string | null;
  status: string;
  created_at: string;
  meeting_url: string;
}

export interface BookingCreate {
  appointment_at: string;
  room_id: string;
  agenda: string;
  guest_name?: string;
  guest_email?: string;
  selfie_b64?: string;
}

export interface BookingListResponse {
  items: Booking[];
  total: number;
}

export interface AccessCardData {
  id: string;
  booking_id: string;
  card_image_b64: string | null;
  guest_card_image_b64: string | null;
  qr_payload: string | null;
}

export type MeetingState = 'waiting' | 'ready' | 'active' | 'expired' | 'completed';

export interface MeetingClientContext {
  booking_id: string;
  state: MeetingState;
  room_name: string;
  client_name: string | null;
  guest_name: string | null;
  appointment_at: string;
  meeting_url: string;
  agenda: string | null;
  fais_acknowledged: boolean;
}

export interface MeetingGuestContext {
  state: MeetingState;
  room_name: string;
  guest_name: string | null;
  fais_acknowledged: boolean;
}

export type MeetingContext = MeetingClientContext | MeetingGuestContext;

export function isClientContext(ctx: MeetingContext): ctx is MeetingClientContext {
  return 'booking_id' in ctx;
}

export const ROOMS = [
  { id: 'tau-13', name: 'Tau Room 13' },
  { id: 'indaba-1', name: 'Indaba Room' },
  { id: 'limpopo-2', name: 'Limpopo Suite' },
  { id: 'ubuntu-5', name: 'Ubuntu Room 5' },
  { id: 'serengeti-3', name: 'Serengeti Lounge' },
] as const;
